export const endpoint = 'https://portalclubesesi.fiemg.com.br/api'

// HML
// export const endpoint = 'https://portalclubesesihml.fiemg.com.br/api'



export let bearer = "";

export const setBearer = (token: string) => {
  bearer = token;
};

export const version = 'v.2.0.14'